export const getAuthHeaders = () => {
    const idToken = localStorage.getItem('token');
    if (!idToken) {
      // Optionally, redirect to login
      window.location.href = '/login';
      throw new Error('No authentication token found. Redirecting to login.');
    }
  
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };
  };